import React from "react";

/**
 * CommonInput - Premium rounded pill text / number / email / password input.
 *
 * Props:
 *   label       {string}   Label shown above the input
 *   required    {boolean}  Appends a red asterisk to the label
 *   type        {string}   HTML input type (default: "text")
 *   placeholder {string}
 *   value       {any}
 *   onChange    {function}
 *   readOnly    {boolean}
 *   disabled    {boolean}
 *   height      {string}   Input height (default: "45px")
 *   error       {string}   Error message to display below the input
 *   style       {object}   Extra style overrides for the input element
 *   className   {string}   Extra classes for the input element
 *   labelClass  {string}   Extra classes for the label element
 *   wrapClass   {string}   Extra classes for the wrapping div
 */
const CommonInput = ({
  label,
  required = false,
  type = "text",
  placeholder = "",
  value,
  onChange,
  readOnly = false,
  disabled = false,
  height = "45px",
  error,
  prefix,
  suffix,
  style = {},
  className = "",
  labelClass = "",
  wrapClass = "",
  ...props
}) => {
  return (
    <div className={`common-input-wrapper ${wrapClass}`}>
      {label && (
        <label className={`fw-bold text-black fs-14 mb-2 ${labelClass}`}>
          {label}
          {required && <span className="text-danger ms-1">*</span>}
        </label>
      )}
      <div className="position-relative">
        {prefix && (
          <div
            className="position-absolute d-flex align-items-center justify-content-center text-muted fw-medium"
            style={{
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 2,
              height: "70%",
              borderRight: "1px solid #eee",
              paddingRight: "12px",
              fontSize: "14px",
            }}
          >
            {prefix}
          </div>
        )}
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          disabled={disabled}
          className={`form-control common-input-field ${className}`}
          {...props}
          style={{
            height: height,
            backgroundColor: readOnly || disabled ? "#f8f9fa" : "#fff",
            color: readOnly || disabled ? "#adb5bd" : "inherit",
            border: error ? "1px solid #ff5e5e" : "1px solid #d5dfe7",
            borderRadius: "0.75rem",
            paddingLeft: prefix ? "60px" : "20px",
            paddingRight: suffix ? "45px" : "20px",
            ...style,
          }}
        />
        {suffix && (
          <div
            className="position-absolute d-flex align-items-center justify-content-center text-muted"
            style={{
              right: "15px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 2,
            }}
          >
            {suffix}
          </div>
        )}
      </div>
      {error && <div className="text-danger fs-12 mt-1 ms-3">{error}</div>}

      <style>{`
        .common-input-field:focus {
          border-color: #003b95 !important;
          box-shadow: none !important;
          background-color: #fff !important;
        }
        .common-input-field::placeholder {
          color: #adb5bd;
        }
      `}</style>
    </div>
  );
};

export default CommonInput;
